import { render, staticRenderFns } from "./nowy-wyscig-kosmiczny.md?vue&type=template&id=6f10b450&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports